import { render } from "./noticeList.vue?vue&type=template&id=6d837e20&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"

import "./noticeList.vue?vue&type=style&index=0&id=6d837e20&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d837e20"]])

export default __exports__